/**
 * Block "Dintorni": al passaggio del mouse (o focus) su una voce, mostra
 * l'immagine associata (per id) allineata verticalmente alla voce stessa.
 * Le visual sono nascoste via CSS su mobile/touch: lì niente di tutto questo.
 */
export function initDintorni() {
	document.querySelectorAll( '.tm-dintorni' ).forEach( ( section ) => {
		const container = section.querySelector( '[data-dint-in]' );
		const items     = section.querySelectorAll( '[data-dint-key]' );
		const visuals   = section.querySelectorAll( '[data-dint-img]' );
		if ( ! container || ! items.length || ! visuals.length ) {
			return;
		}

		// Allinea la foto al centro verticale della voce, senza sforare la sezione.
		const position = ( visual, item ) => {
			const cRect    = container.getBoundingClientRect();
			const iRect    = item.getBoundingClientRect();
			const visualH  = visual.offsetHeight || visual.offsetWidth * 5 / 4;
			const safe     = 16;
			const min      = visualH / 2 + safe;
			const max      = container.offsetHeight - visualH / 2 - safe;
			const top      = iRect.top - cRect.top + iRect.height / 2;
			visual.style.top = Math.max( min, Math.min( max, top ) ) + 'px';
		};

		const activate = ( item ) =>
			visuals.forEach( ( v ) => {
				const on = v.dataset.dintImg === item.dataset.dintKey;
				if ( on ) {
					position( v, item );
				}
				v.classList.toggle( 'is-active', on );
			} );
		const clear = () => visuals.forEach( ( v ) => v.classList.remove( 'is-active' ) );

		items.forEach( ( item ) => {
			item.addEventListener( 'mouseenter', () => activate( item ) );
			item.addEventListener( 'mouseleave', clear );
			item.addEventListener( 'focus', () => activate( item ) );
			item.addEventListener( 'blur', clear );
		} );
	} );
}
